export const useSxStyles = () => {
  return {
    hourlyComponent: {
      display: 'flex',
      gap: 1,
      flexDirection: 'column',
    },
    fieldRow: {
      display: 'grid',
      gap: 2,
      gridTemplateColumns: '1fr 1fr',
    },
  };
};
